import { getAPI , postAPI } from "../../../../api/apis"
import { REACT_APP_CONTRACT, REACT_APP_CONTRACTSIGN } from '../../../../utils/common'

export async function getSignatureUrlApi(candidateJobId: any) {
    const Details = getAPI( REACT_APP_CONTRACTSIGN + `/contract-document-details/${candidateJobId}`)
    return Details
}

export async function contractDetails(body: any) {
    const Details =  postAPI( REACT_APP_CONTRACT + `/contract-details`, body)
    return Details
}
